import { TariffPlans } from 'src/components/TariffPlans';
import { BlockTypes, type ProductBlock } from 'src/types/contentBlocks';
import { About } from 'src/uikit/About';
import { Accordion } from 'src/uikit/Accordion';
import { Benefits } from 'src/uikit/Benefits';
import { ClientCasesCarousel } from 'src/uikit/Carousels';
import { ReviewsCarousel } from 'src/uikit/Carousels/ReviewsCarousel';
import { DemoSection } from 'src/uikit/DemoSection';
import { Documentation } from 'src/uikit/Documentation';
import { FullScreen } from 'src/uikit/FullScreen';
import { Table } from 'src/uikit/Table';
import { type TabType } from 'src/uikit/Tabs';

import { ProductsList } from '../../uikit/ProductsList';
import { AdvantagesCarousel } from '../Carousel/Carousels';
import { WebinarsCarousel } from '../Carousel/Carousels/WebinarCarousel';
import { CalculatorProduct } from '../ProductDetailed/CalculatorProduct';
import { PromoBanner } from '../Restyling/PromoBanner';
import { Consultation } from './Consultation';
import { Banner, CatalogSection } from './helperComponents';

export const renderBlocks =
  (blocks: ProductBlock[]) =>
  (onConsultationClick: () => void = () => {}) =>
    blocks.map(({ type, data }, index) => {
      switch (type) {
        case BlockTypes.About:
          return <About key={index} {...data} id={data.id} />;

        case BlockTypes.BenefitsPrimary:
          data.cards.forEach((card) => {
            card.icon = card.icon ? card.icon : card.previewImage;
          });
          return (
            <Benefits key={index} {...data} type={Benefits.type.PrimaryCard} />
          );

        case BlockTypes.BenefitsPreview:
          return (
            <Benefits key={index} {...data} type={Benefits.type.PreviewCard} />
          );

        case BlockTypes.Calculator:
          const title = data.title ? data.title : 'Рассчитайте стоимость';
          const CalculatorComponent = data.isTariffPlans ? (
            <TariffPlans
              title={title}
              tariffPlansType="product"
              initialActiveProduct={data.initialActiveProduct}
            />
          ) : (
            <CalculatorProduct
              title={title}
              initialActiveProduct={data.initialActiveProduct}
            />
          );
          return (
            <section key={index} id={data.id}>
              {CalculatorComponent}
            </section>
          );
        case BlockTypes.Documentation:
          return <Documentation key={index} {...data} />;

        case BlockTypes.DemoSectionSingleImage:
        case BlockTypes.DemoSectionSingleVideo:
          return (
            <DemoSection
              key={index}
              id={data.id}
              title={data.title}
              richText={data.richText}
              video={data.video}
              image={data.image}
              contentLeft={data.contentLeft}
              button={
                data.button
                  ? {
                      title: data.button?.title,
                      link: data.button?.link,
                      uniqueId: data.title,
                    }
                  : undefined
              }
            />
          );

        case BlockTypes.DemoSectionTabsImages:
        case BlockTypes.DemoSectionTabsVideos:
        case BlockTypes.DemoSectionTabsText: {
          const tabs: TabType[] = [];

          const images: {
            id: string;
            image: string;
            title?: string;
            subtitle?: string;
          }[] = [];

          const videos: {
            id: string;
            link: string;
            controls?: boolean;
            previewImage?: string;
          }[] = [];

          const richTexts: {
            id: string;
            richText: string;
          }[] = [];

          data.tabs.map((tab, index) => {
            tabs.push({
              title: tab.title,
              id: (index + 1).toString(),
              isDisabled: tab.isDisabled,
            });

            tab.image &&
              images.push({
                id: (index + 1).toString(),
                image: tab.image.image,
                title: tab.image.title,
                subtitle: tab.image.subtitle,
              });

            tab.video &&
              videos.push({
                id: (index + 1).toString(),
                link: tab.video.link,
                controls: tab.video.controls,
              });

            tab.richText &&
              richTexts.push({
                id: (index + 1).toString(),
                richText: tab.richText,
              });
          });

          return (
            <DemoSection
              key={index}
              id={data.id}
              title={data.title}
              tabs={tabs}
              images={images.length >= 1 ? images : undefined}
              videos={videos.length >= 1 ? videos : undefined}
              richTexts={richTexts}
              button={
                data.button
                  ? {
                      title: data.button?.title,
                      link: data.button?.link,
                      uniqueId: data.title,
                    }
                  : undefined
              }
              type={DemoSection.type.Tabs}
            />
          );
        }

        case BlockTypes.FullScreenVideo:
        case BlockTypes.FullScreenImage:
          return <FullScreen key={index} {...data} />;

        case BlockTypes.Accordion:
          return <Accordion key={index} {...data} />;

        case BlockTypes.Table:
          return <Table key={index} {...data} />;

        case BlockTypes.Carousel:
          return <WebinarsCarousel key={index} {...data} />;

        case BlockTypes.FeedbackCarousel:
          return <ReviewsCarousel key={index} {...data} />;

        case BlockTypes.Consultation:
          return (
            <Consultation
              key={index}
              data={data}
              onClick={onConsultationClick}
            />
          );

        case BlockTypes.CasesCarousel:
          return (
            <ClientCasesCarousel
              key={index}
              {...data}
              slides={data.cards || []}
            />
          );

        case BlockTypes.ProductsList:
          return (
            <ProductsList key={index} id={data.id} {...data.productsData} />
          );

        case BlockTypes.Banner:
          return <Banner {...data} />;

        case BlockTypes.PromoBanner:
          return <PromoBanner {...data} />;

        case BlockTypes.CatalogSection:
          return <CatalogSection {...data} />;

        case BlockTypes.AdvantagesCarousel:
          return <AdvantagesCarousel {...data} />;
      }
    });
